// extracted by mini-css-extract-plugin
export default {"infoIcon":"InfoButton-index__infoIcon--p3X3J","utmInfoModal":"InfoButton-index__utmInfoModal--FST61"};